<template>
  <div style="color:#6c757d !important;">
    <!-- ----------------------------------- -->
    <!-- navbar starts -->
    <vs-navbar
      v-model="indexActive"
      :color="colorx"
      text-color="rgba(255,255,255,.6)"
      active-text-color="rgba(255,255,255,1)"
      class="myNavbar"
    >
      <div slot="title">
        <vs-navbar-title>Graphs Presentations</vs-navbar-title>
      </div>
    </vs-navbar>
    <!-- navbar ends -->
    <!-- ----------------------------------- -->
    <!-- container starts -->
    <div class="container mt-5">
      <div class="row">
        <div class="col-sm-12 p-0 print-scr">
          <span class="btn btn-primary float-right btn-sm print-btn" @click="printReport">
            <i class="material-icons">print</i> Print
          </span>
          <vs-breadcrumb
            align="left"
            :items="
                  [
                   {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/program-officer/todoList'
                    },
                    {
                      title: 'Reports',
                      url: '/#/dashboard/Admin/graphs',
                      active: true
                    }
                  ]"
          ></vs-breadcrumb>
        </div>
      </div>
    </div>
    <div class="container mt-2 mb-5">
      <!-- row starts -->
      <div class="row">
        <!-- col-md starts -->
        <div class="col-md-6 mb-3 pl-0">
          <div class="graph-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">Month Wise Assigned Trainings</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr class="sm-screen">
                          <td>
                            <selectize v-model="topicSelected" :settings="topicSetting">
                              <option value="training">Trainings</option>
                              <option value="fundingAgency">Funding Agency</option>
                              <option value="thematicArea">Thematic Area</option>
                              <option value="project">Project</option>
                              <option value="subProgram">Subprogram</option>
                              <option value="department">Department</option>
                            </selectize>
                          </td>
                          <td>
                            <selectize v-model="startDateMonth" :settings="startDateSetting">
                              <option
                                v-for="(item,index) in yearArr"
                                :key="index"
                                :value="item.id"
                                :text="item.value"
                                class="text-capitalize"
                              >{{item.value}}</option>
                            </selectize>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9;">
              <canvas id="bar-chart" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->

        <div class="col-md-6 mb-3 pl-0">
          <div class="graph-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">In Queue Trainings</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr class="sm-screen">
                          <td>
                            <selectize v-model="topicSelectedQue" :settings="topicSetting">
                              <option value="training">Trainings</option>
                              <option value="fundingAgency">Funding Agency</option>
                              <option value="thematicArea">Thematic Area</option>
                              <option value="project">Project</option>
                              <option value="subProgram">Subprogram</option>
                              <option value="department">Department</option>
                            </selectize>
                          </td>
                          <td>
                            <selectize v-model="startDateMonthQue" :settings="startDateSetting">
                              <option
                                v-for="(item,index) in yearArr"
                                :key="index"
                                :value="item.id"
                                :text="item.value"
                                class="text-capitalize"
                              >{{item.value}}</option>
                            </selectize>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
              <canvas id="bar-chart-grouped-2" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->

        <!-- col-md starts -->
        <div class="col-md-6 mb-3 pl-0">
          <div class="graph-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">In Progress Trainings</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr class="sm-screen">
                          <td>
                            <selectize v-model="topicSelectedProg" :settings="topicSetting">
                              <option value="training">Trainings</option>
                              <option value="fundingAgency">Funding Agency</option>
                              <option value="thematicArea">Thematic Area</option>
                              <option value="project">Project</option>
                              <option value="subProgram">Subprogram</option>
                              <option value="department">Department</option>
                            </selectize>
                          </td>
                          <td>
                            <selectize v-model="startDateMonthProg" :settings="startDateSetting">
                              <option
                                v-for="(item,index) in yearArr"
                                :key="index"
                                :value="item.id"
                                :text="item.value"
                                class="text-capitalize"
                              >{{item.value}}</option>
                            </selectize>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
              <canvas id="bar-chart-grouped-3" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-6 mb-3 pl-0">
          <div class="graph-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">Assigned Trainings by Advisor</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr>
                          <td>
                            <selectize v-model="topicSelectedAssign" :settings="topicSetting">
                              <option value="training">Trainings</option>
                              <option value="fundingAgency">Funding Agency</option>
                              <option value="thematicArea">Thematic Area</option>
                              <option value="project">Project</option>
                              <option value="subProgram">Subprogram</option>
                              <option value="department">Department</option>
                            </selectize>
                          </td>
                          <td>
                            <selectize v-model="startDateAssign" :settings="startDateSetting">
                              <option
                                v-for="(item,index) in yearArr"
                                :key="index"
                                :value="item.id"
                                :text="item.value"
                                class="text-capitalize"
                              >{{item.value}}</option>
                            </selectize>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
              <canvas class="chart-container" id="myChart" width="400" height="400"></canvas>
            </div>
          </div>
        </div>

        <!-- col-md ends -->
        <!-- col-md starts -->
        <div class="col-md-6 mb-3 pl-0">
          <div class="graph-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">Trainer(s)</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr class="sm-screen">
                          <td class="training-width" style="width: 33%;">
                            <selectize v-model="selected">
                              <!-- settings is optional -->
                              <option :value="1">Trainer 1</option>
                              <option :value="2">Trainer 2</option>
                            </selectize>
                          </td>
                          <td>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff;font-size:13px;"
                              placeholder="Start Date"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </td>
                          <td>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff;font-size:13px;"
                              placeholder="End Date"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
              <canvas id="bar-chart-grouped-4" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->

        <!-- col-md starts -->
        <div class="col-md-6 mb-3 pl-0">
          <div class="graph-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">Total Participants(s)</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr class="sm-screen">
                          <td class="training-width" style="width: 33%;">
                            <selectize v-model="selected">
                              <!-- settings is optional -->
                              <option :value="1">Training Title 1</option>
                              <option :value="2">Training Title 2</option>
                            </selectize>
                          </td>
                          <td>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff;font-size:13px;"
                              placeholder="Start Date"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </td>
                          <td>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff;font-size:13px;"
                              placeholder="End Date"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
              <canvas id="bar-chart-grouped-5" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->

        <!-- col-md starts -->
        <div class="col-md-6 mb-3 pl-0">
          <div class="graph-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">Funding Agency(s)</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr class="sm-screen">
                          <td class="training-width" style="width: 33%;">
                            <selectize v-model="selected" :settings="settings">
                              <!-- settings is optional -->
                              <option :value="1">Funding Agency 1</option>
                              <option :value="2">Funding Agency 2</option>
                            </selectize>
                          </td>
                          <td>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff;font-size:13px;"
                              placeholder="Start Date"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </td>
                          <td>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff;font-size:13px;"
                              placeholder="End Date"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
              <canvas id="bar-chart-grouped-6" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->

        <!-- col-md starts -->
        <div class="col-md-6 mb-3 pl-0">
          <div class="graph-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">Thematic Area</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr class="sm-screen">
                          <td class="training-width" style="width: 33%;">
                            <selectize v-model="selected" :settings="settings">
                              <!-- settings is optional -->
                              <option :value="1">Thematic Area 1</option>
                              <option :value="2">Thematic Area 2</option>
                            </selectize>
                          </td>
                          <td>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff;font-size:13px;"
                              placeholder="Start Date"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </td>
                          <td>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff;font-size:13px;"
                              placeholder="End Date"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
              <canvas id="bar-chart-grouped-7" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->

        <!-- col-md starts -->
        <div class="col-md-6 mb-3 pl-0">
          <div class="graph-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">Subprogram</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr class="sm-screen">
                          <td class="training-width" style="width: 33%;">
                            <selectize v-model="selected" :settings="settings">
                              <!-- settings is optional -->
                              <option :value="1">Subprogram 1</option>
                              <option :value="2">Subprogram 2</option>
                            </selectize>
                          </td>
                          <td>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff;font-size:13px;"
                              placeholder="Start Date"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </td>
                          <td>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff;font-size:13px;"
                              placeholder="End Date"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
              <canvas id="bar-chart-grouped-8" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->

        <!-- col-md starts -->
        <div class="col-md-6 mb-3 pl-0">
          <div class="graph-box">
            <p class="mt-2 mb-2">
              <span>
                <strong class="title">Department</strong>
                <hr class="line-bordered" />
                <div class="row print-scr">
                  <div class="col-sm-12 mt-0">
                    <strong class="title">Filter By</strong>
                    <table class="table">
                      <tbody class="line-bordered">
                        <tr class="sm-screen">
                          <td class="training-width" style="width: 33%;">
                            <selectize v-model="selected" :settings="settings">
                              <!-- settings is optional -->
                              <option :value="1">Department 1</option>
                              <option :value="2">Department 2</option>
                            </selectize>
                          </td>
                          <td>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff;font-size:13px;"
                              placeholder="Start Date"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </td>
                          <td>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff;font-size:13px;"
                              placeholder="End Date"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </span>
            </p>
            <div class="line-bordered col-sm-8 offset-sm-2" style="background:#f9f9f9">
              <canvas id="bar-chart-grouped-9" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
        <!-- col-md ends -->
      </div>
      <!-- row ends -->
    </div>
    <!-- container ends -->
  </div>
</template>

<script>
// import Chart from "chart.js";
import Selectize from "vue2-selectize";
import axios from "axios";
import Chart from "chart.js";
// flatPickr
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data: () => ({
    colorx: "#2196f3",
    basepath: localStorage.getItem("BASE_PATH"),
    indexActive: 0,
    selected: 1,
    monthWiseAssignedME: [],
    InQueueTraining: [],
    InProgressTraining: [],
    dateRange: [],
    dateOptions: {
      wrap: true,
      dateFormat: "d-m-Y"
    },
    startDateSetting: {
      delimiter: "|",
      placeholder: "Select Year"
    },
    topicSetting: {
      delimiter: "|",
      placeholder: "Select Topic"
    },
    yearArr: [],
    // month wise training
    topicSelected: "",
    startDateMonth: "",
    monthWiseChart: "",
    dataMonth: [],
    // End month wise training
  // in queue training
    topicSelectedQue: "",
    startDateMonthQue: "",
    queChart: "",
    dataQue: [],
    // End in queue training
    // in prog training
    topicSelectedProg: "",
    startDateMonthProg: "",
    progChart: "",
    dataProg: [],
    // End in prog training
    // assign training
    topicSelectedAssign: "",
    startDateAssign: "",
    assignChart: "",
    dataAssign: [],
    assigned: "",
    // End assign training
  }),
  watch: {
    // month
    topicSelected(){
      this.showMonthWiseGraph();
    },
    startDateMonth(){
      this.showMonthWiseGraph();
    },
    // --month
    // queue
    topicSelectedQue(){
      this.showQueGraph();
    },
    startDateMonthQue(){
      this.showQueGraph();
    },
    // --queue
    // prog
    topicSelectedProg(){
      this.showProgGraph();
    },
    startDateMonthProg(){
      this.showProgGraph();
    },
    // --prog
  // assign training
    topicSelectedAssign(){
      this.showAssignGraph();
    },
    startDateAssign(){
      this.showAssignGraph();
    },
    // --assign training
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.showYear();
    this.showMonthWiseOnload();
    this.showQueOnload();
    this.showProgOnload();
    this.showAssignOnload();
    
  },
  methods: {
    showMonthWiseOnload: function showMonthWiseOnload(){
      axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/monthwise/programofficer/assigned/training/get/" +
          JSON.parse(localStorage.getItem("currentUser")).id
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response.data) {
          this.monthWiseAssignedME = response.data;
          this.monthWiseChart = new Chart(document.getElementById("bar-chart"), {
            type: "line",
            data: {
              labels: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
              ],
              datasets: [
                {
                  label: "No of training's",
                  backgroundColor: "#f1c40f",
                  data: [
                    this.monthWiseAssignedME[0],
                    this.monthWiseAssignedME[1],
                    this.monthWiseAssignedME[2],
                    this.monthWiseAssignedME[3],
                    this.monthWiseAssignedME[4],
                    this.monthWiseAssignedME[5],
                    this.monthWiseAssignedME[6],
                    this.monthWiseAssignedME[7],
                    this.monthWiseAssignedME[8],
                    this.monthWiseAssignedME[9],
                    this.monthWiseAssignedME[10],
                    this.monthWiseAssignedME[11],
                    this.monthWiseAssignedME[12]
                  ]
                }
              ]
            },
            options: {
              scales: {
                yAxes: [
                  {
                    ticks: {
                      min: 0,
                      max: 50,
                      callback: function(value) {
                        return value + " ";
                      }
                    },
                    scaleLabel: {
                      display: true,
                      labelString: "No. of Trainings"
                    }
                  }
                ]
              }
            }
          });
        }
      });
    },
    showQueOnload: function showQueOnload(){
      // IN QUEUE Trainings
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/monthwise/programofficer/InQueue/training/get/" +
          JSON.parse(localStorage.getItem("currentUser")).id
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response.data) {
          this.InQueueTraining = response.data;
          this.queChart = new Chart(document.getElementById("bar-chart-grouped-2"), {
            type: "pie",
            data: {
              labels: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "July",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
              ],
              datasets: [
                {
                  backgroundColor: [
                    "#f1c40f",
                    "#e74c3c",
                    "#2ecc71",
                    "#3498db",
                    "#95a5a6",
                    "#8e5ea2",
                    "#A7414A",
                    "#A37C27",
                    "#F28A30",
                    "#93A806",
                    "#86618F",
                    "#03353E"
                  ],
                  data: [
                    this.InQueueTraining[0],
                    this.InQueueTraining[1],
                    this.InQueueTraining[2],
                    this.InQueueTraining[3],
                    this.InQueueTraining[4],
                    this.InQueueTraining[5],
                    this.InQueueTraining[6],
                    this.InQueueTraining[7],
                    this.InQueueTraining[8],
                    this.InQueueTraining[9],
                    this.InQueueTraining[10],
                    this.InQueueTraining[11],
                    this.InQueueTraining[12]
                  ]
                }
              ]
            }
          });
        }
      });
    },
    // this shows inprogress graph
    showProgOnload: function showProgOnload(){
      this.openLoading();
    axios.get(
        localStorage.getItem("BASE_PATH") +
          "/monthwise/programofficer/InProgress/training/get/" +
          JSON.parse(localStorage.getItem("currentUser")).id
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.dataProg = [];
        setTimeout(() => {
          response.data.forEach((item) => {
                if(item.months == 1){
                  this.dataProg[0] = item.trngCount;
                } else if(item.months == 2) {
                  this.dataProg[1] = item.trngCount;
                } else if(item.months == 3) {
                  this.dataProg[2] = item.trngCount;
                } else if(item.months == 4) {
                  this.dataProg[3] = item.trngCount;
                } else if(item.months == 5) {
                  this.dataProg[4] = item.trngCount;
                } else if(item.months == 6) {
                  this.dataProg[5] = item.trngCount;
                } else if(item.months == 7) {
                  this.dataProg[6] = item.trngCount;
                } else if(item.months == 8) {
                  this.dataProg[7] = item.trngCount;
                } else if(item.months == 9) {
                  this.dataProg[8] = item.trngCount;
                } else if(item.months == 10) {
                  this.dataProg[9] = item.trngCount;
                } else if(item.months == 11) {
                  this.dataProg[10] = item.trngCount;
                } else if(item.months == 12) {
                  this.dataProg[11] = item.trngCount;
                }
              })
          this.progChart = new Chart(document.getElementById("bar-chart-grouped-3"), {
            type: "pie",
            data: {
              labels: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "July",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
              ],
              datasets: [
                {
                  backgroundColor: [
                    "#f1c40f",
                    "#e74c3c",
                    "#2ecc71",
                    "#3498db",
                    "#95a5a6",
                    "#8e5ea2",
                    "#A7414A",
                    "#A37C27",
                    "#F28A30",
                    "#93A806",
                    "#86618F",
                    "#03353E"
                  ],
                  data: this.dataProg
                }
              ]
            }
          });
        })
      })

    },
    // this shows assign chart
    showAssignOnload: function showAssignOnload(){
      this.openLoading();
      axios.get(
        localStorage.getItem("BASE_PATH") +
          "/assigned/training/" +
          JSON.parse(localStorage.getItem("currentUser")).id+"/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
      this.closeLoading();
      this.assigned = 0; this.inQueue = []; this.inProgress = [];
      setTimeout(() => {
          response.data.forEach((item) => {
            if(item.trainingstatus == "In Queue"){
              this.inQueue.push(item.id);
            }
            if(item.trainingstatus == "In Progress"){
              this.inProgress.push(item.id);
            }
            
          })
          this.assigned = this.inQueue.length+this.inProgress.length;
      this.assignChart = new Chart(document.getElementById("myChart"), {
          type: "bar",
          data: {
            labels: [" "],
            datasets: [
              {
                label: ["Assigned By Advisor"],
                data: [this.assigned],
                backgroundColor: "#e74c3c"
              },
              {
                label: ["In Queue Trainings"],
                data: [this.inQueue.length],
                backgroundColor: "#3498db"
              },
              {
                label: ["In Progress Trainings"],
                data: [this.inProgress.length],
                backgroundColor: "#95a5a6"
              }
            ]
          },
          options: {
            scales: {
              yAxes: [
                {
                  ticks: {
                    min: 0,
                    max: 50,
                    callback: function(value) {
                      return value + " ";
                    }
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "No. of Trainings"
                  }
                }
              ]
            }
          }
        });
      })
      })
    },
    // this shows month wise graph by filter
    showMonthWiseGraph: function showMonthWiseGraph(){
      if(this.topicSelected != "" && this.startDateMonth != ""){
      this.openLoading();
      axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/monthwise/filter/" +
          JSON.parse(localStorage.getItem("currentUser")).id+"/"+this.topicSelected+"/"+this.startDateMonth+"/get"
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.dataMonth = [0,0,0,0,0,0,0,0,0,0,0,0];
          if(response.data){
            setTimeout(() => {
              response.data.forEach((item) => {
                if(item.months == 1){
                  this.dataMonth[0] = item.trngCount;
                } else if(item.months == 2) {
                  this.dataMonth[1] = item.trngCount;
                } else if(item.months == 3) {
                  this.dataMonth[2] = item.trngCount;
                } else if(item.months == 4) {
                  this.dataMonth[3] = item.trngCount;
                } else if(item.months == 5) {
                  this.dataMonth[4] = item.trngCount;
                } else if(item.months == 6) {
                  this.dataMonth[5] = item.trngCount;
                } else if(item.months == 7) {
                  this.dataMonth[6] = item.trngCount;
                } else if(item.months == 8) {
                  this.dataMonth[7] = item.trngCount;
                } else if(item.months == 9) {
                  this.dataMonth[8] = item.trngCount;
                } else if(item.months == 10) {
                  this.dataMonth[9] = item.trngCount;
                } else if(item.months == 11) {
                  this.dataMonth[10] = item.trngCount;
                } else if(item.months == 12) {
                  this.dataMonth[11] = item.trngCount;
                }
              })
          this.monthWiseChart.destroy();
          this.monthWiseChart = new Chart(document.getElementById("bar-chart"), {
            type: "line",
            data: {
              labels: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
              ],
              datasets: [
                {
                  label: this.topicSelected,
                  backgroundColor: "#f1c40f",
                  data: this.dataMonth
                }
              ]
            },
            options: {
              scales: {
                yAxes: [
                  {
                    ticks: {
                      min: 0,
                      max: 50,
                      callback: function(value) {
                        return value + " ";
                      }
                    },
                    scaleLabel: {
                      display: true,
                      labelString: this.topicSelected
                    }
                  }
                ]
              }
            }
          });
        })
          }
      });
      }
    },

    // this shows in queue training on filter
    showQueGraph: function showQueGraph(){
      if(this.topicSelectedQue != "" && this.startDateMonthQue != ""){
      this.openLoading();
      axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/inqueue/filter/" +
          JSON.parse(localStorage.getItem("currentUser")).id+"/"+this.topicSelectedQue+"/"+this.startDateMonthQue+"/get"
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.dataQue = [];
          if(response.data){
            setTimeout(() => {
              response.data.forEach((item) => {
                if(item.months == 1){
                  this.dataQue[0] = item.trngCount;
                } else if(item.months == 2) {
                  this.dataQue[1] = item.trngCount;
                } else if(item.months == 3) {
                  this.dataQue[2] = item.trngCount;
                } else if(item.months == 4) {
                  this.dataQue[3] = item.trngCount;
                } else if(item.months == 5) {
                  this.dataQue[4] = item.trngCount;
                } else if(item.months == 6) {
                  this.dataQue[5] = item.trngCount;
                } else if(item.months == 7) {
                  this.dataQue[6] = item.trngCount;
                } else if(item.months == 8) {
                  this.dataQue[7] = item.trngCount;
                } else if(item.months == 9) {
                  this.dataQue[8] = item.trngCount;
                } else if(item.months == 10) {
                  this.dataQue[9] = item.trngCount;
                } else if(item.months == 11) {
                  this.dataQue[10] = item.trngCount;
                } else if(item.months == 12) {
                  this.dataQue[11] = item.trngCount;
                }
              })
          this.queChart.destroy();
          this.queChart = new Chart(document.getElementById("bar-chart-grouped-2"), {
            type: "pie",
            data: {
              labels: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "July",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
              ],
              datasets: [
                {
                  backgroundColor: [
                    "#f1c40f",
                    "#e74c3c",
                    "#2ecc71",
                    "#3498db",
                    "#95a5a6",
                    "#8e5ea2",
                    "#A7414A",
                    "#A37C27",
                    "#F28A30",
                    "#93A806",
                    "#86618F",
                    "#03353E"
                  ],
                  data: this.dataQue
                }
              ]
            }
          });
        })
          }
      });
      }
    },
    // this shows in progress training on filter graph
    // this shows inprogress graph
    showProgGraph: function showProgGraph(){
    if(this.topicSelectedProg != "" && this.startDateMonthProg != ""){
      this.openLoading();
    axios.get(
        localStorage.getItem("BASE_PATH") +
          "/inprogress/filter/" +
          JSON.parse(localStorage.getItem("currentUser")).id+"/"+this.topicSelectedProg+"/"+this.startDateMonthProg+"/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.dataProg = [];
        setTimeout(() => {
          response.data.forEach((item) => {
                if(item.months == 1){
                  this.dataProg[0] = item.trngCount;
                } else if(item.months == 2) {
                  this.dataProg[1] = item.trngCount;
                } else if(item.months == 3) {
                  this.dataProg[2] = item.trngCount;
                } else if(item.months == 4) {
                  this.dataProg[3] = item.trngCount;
                } else if(item.months == 5) {
                  this.dataProg[4] = item.trngCount;
                } else if(item.months == 6) {
                  this.dataProg[5] = item.trngCount;
                } else if(item.months == 7) {
                  this.dataProg[6] = item.trngCount;
                } else if(item.months == 8) {
                  this.dataProg[7] = item.trngCount;
                } else if(item.months == 9) {
                  this.dataProg[8] = item.trngCount;
                } else if(item.months == 10) {
                  this.dataProg[9] = item.trngCount;
                } else if(item.months == 11) {
                  this.dataProg[10] = item.trngCount;
                } else if(item.months == 12) {
                  this.dataProg[11] = item.trngCount;
                }
              })
            this.progChart.destroy();
          this.progChart = new Chart(document.getElementById("bar-chart-grouped-3"), {
            type: "pie",
            data: {
              labels: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "July",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
              ],
              datasets: [
                {
                  backgroundColor: [
                    "#f1c40f",
                    "#e74c3c",
                    "#2ecc71",
                    "#3498db",
                    "#95a5a6",
                    "#8e5ea2",
                    "#A7414A",
                    "#A37C27",
                    "#F28A30",
                    "#93A806",
                    "#86618F",
                    "#03353E"
                  ],
                  data: this.dataProg
                }
              ]
            }
          });
        })
      })
      }
    },
    // this shows year
    showYear: function showYear(){
      for(var i = 0; i <= 35; i++){
        this.yearArr.push({"id": 2015+i, "value": 2015+i});
      }
    },

    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    printReport: function() {
      window.print();
    }
  },
  components: {
    Selectize,
    flatPickr
  }
};
</script>
<style scoped>
.myNavbar {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1), 0 5px 5px rgba(0, 0, 0, 0.1) !important;
}
.nav-route-link {
  background: none !important;
  border-right: 0px !important;
}
.graph-box {
  border: 3px solid #2196f3;
  padding: 10px;
}
.line-bordered {
  border: 0.5px solid #2196f36b;
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

strong.title {
  color: #2196f3;
}

tbody.bordered {
  border: 1px solid #2196f3;
}

.selectize-input {
  border: 1px solid #333 !important;
}

table .td {
  border-top: 1px solid #2196f3;
}
@media only screen and (max-width: 600px) {
  .training-width {
    width: 100% !important;
  }
  .sm-screen {
    display: grid !important;
  }
}
@media only screen and (max-width: 992px) {
  .training-width {
    width: 100% !important;
  }
  .sm-screen {
    display: grid !important;
  }
}
</style>
<style>
.vs-navbar--header {
  height: 60px;
  padding: 20px;
}
.vs-con-items {
  padding: 20px;
}
@media screen and (max-width: 800px) {
  .vs-con-items.activeMenuResponsive {
    background-color: #46637a !important;
  }
}
</style>